export default __webpack_public_path__ + "static/media/7.cf710bf9.png";